import Vue from 'vue';
import * as types from './mutation-types';

export const all = (state) => {
    return state.all;
};

export default {
    all
};
